import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { ResumeSGChargeProvider } from "presentation/store/ResumeSGCharge/ResumeSGChargeProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { GridStyles } from "presentation/view/components/styled/NbisTable.styled";
import ResumeSGChargeMaintenance from "presentation/view/section/ResumeSGCharge/ResumeSGChargeMaintenance";

const ResumeSGChargeContMain = () => {
    return <ANAInfoWrapper permission={Permission.RESUME_SG_CHARGE_MAINTENANCE}>
        <MessageBarWrapper>
            <ResumeSGChargeProvider>
                <GridStyles />
                <ResumeSGChargeMaintenance />
            </ResumeSGChargeProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default ResumeSGChargeContMain;